import { createSlotRecipe } from './runtime.mjs';

const switchStyleConfig = {"name":"switchStyle","className":"wd-switch","slots":["root","track","thumb","label"],"defaultVariants":{"disabled":false,"variant":"dark"},"variantMap":{"variant":["dark","light"],"disabled":["true","false"]}}

export const switchStyle = /* @__PURE__ */ createSlotRecipe(switchStyleConfig)